export default __webpack_public_path__ + "static/img/description-pattern.5bb2c24.jpg";